import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate'
})
export class TruncatePipe implements PipeTransform {
    transform(value: string, limit: number = 20, completeWords: boolean = false, ellipsis: string = '...'): string {
        if (!value) return '';
        if (value.length <= limit) return value;

        let truncatedText = value.slice(0, limit);

        if (completeWords) {
            truncatedText = truncatedText.slice(0, truncatedText.lastIndexOf(' '));
        }

        return `${truncatedText}${ellipsis}`;
    }
}
